import { render } from "./RichiestaFerie.vue?vue&type=template&id=d52fc44e&scoped=true"
import script from "./RichiestaFerie.vue?vue&type=script&lang=js"
export * from "./RichiestaFerie.vue?vue&type=script&lang=js"

import "./RichiestaFerie.vue?vue&type=style&index=0&id=d52fc44e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52fc44e"]])

export default __exports__